import { render, staticRenderFns } from "./PictureCollectionUpload.vue?vue&type=template&id=cf126bcc&scoped=true"
import script from "./PictureCollectionUpload.vue?vue&type=script&lang=ts"
export * from "./PictureCollectionUpload.vue?vue&type=script&lang=ts"
import style0 from "./PictureCollectionUpload.vue?vue&type=style&index=0&id=cf126bcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf126bcc",
  null
  
)

export default component.exports